<template>
   <div id="news-layout" :class="{
    'hide-header': nativeQuery.header.indexOf('0') !== -1
  }">
    <!-- 二维码 -->
    <div v-if="contactPanel" class="contact bg wx">
      <div class="scan-code">
        <div class="code">
          <img src="../assets/wechat_code1.png" alt="">
        </div>
      </div>
    </div>
    <div v-if="contactPanel1" class="contact bg wb">
      <div class="scan-code">
        <div class="code">
          <img src="../assets/weibo_code1.png" alt="">
        </div>
      </div>
    </div>
    <div class="header bg">
      <div class="pc-top bg" v-if="isDesktop">
        <div class="nav-box">
          <div
            :class="[ nowIndex + 1  === item ? 'nav-active':'']"
              @click="go(index+1)"
              v-for="(item,index) in navArray"
              :key="item">
            <img
            class="go "
            :src="require(`../assets/${targetFolder}/nav/${item}${ nowIndex + 1  === item ? '_active':''}.png`)">
          </div>
        </div>
        <div class="action-container">
          <img
            class="wechat-button"
              :src="contactPanel === false ? require(`../assets/${targetFolder}/1/ico1.png`) : require(`../assets/${targetFolder}/1/ico1_active.png`)"
            @click="contactPanel = !contactPanel;contactPanel1 = false">
          <img
            class="wechat-button"
              :src="contactPanel1 === false ? require(`../assets/${targetFolder}/1/ico2.png`) : require(`../assets/${targetFolder}/1/ico2_active.png`)"
            @click="contactPanel1 = !contactPanel1;contactPanel = false">
          <a href="https://tieba.baidu.com/wxf/27469939?kw=%E5%85%A8%E6%B0%91%E5%AD%A6%E9%9C%B8%E6%89%8B%E6%B8%B8&fr=sharewise&source=12_16_sharecard_a" target='_blank'>
              <img
              class="tieba-button"
              :src="require(`../assets/${targetFolder}/1/ico3.png`)"
              >
          </a>
          <a href="https://v.douyin.com/6HuBcKP/" target='_blank'>
              <img
              class="dy-button"
              :src="require(`../assets/${targetFolder}/1/ico4.png`)"
              >
          </a>
        </div>
      </div>
      <div v-if="!isDesktop">
        <div class="mobile-top bg">
          <div class="nav-box">
            <img class="logo" :src="require(`../assets/${targetFolder}/nav/logo.png`)" />
            <div class="action-container" >
              <img
                class="wechat-button"
                  :src="contactPanel === false ? require(`../assets/${targetFolder}/nav/ico1.png`) : require(`../assets/${targetFolder}/nav/ico1_active.png`)"
                @click="contactPanel = !contactPanel;contactPanel1 = false;classification=false">
              <img
                class="wechat-button"
                  :src="contactPanel1 === false ? require(`../assets/${targetFolder}/nav/ico2.png`) : require(`../assets/${targetFolder}/nav/ico2_active.png`)"
                @click="contactPanel1 = !contactPanel1;contactPanel = false;classification=false">
              <a class="tieba-button" href="https://tieba.baidu.com/wxf/27469939?kw=%E5%85%A8%E6%B0%91%E5%AD%A6%E9%9C%B8%E6%89%8B%E6%B8%B8&fr=sharewise&source=12_16_sharecard_a" target='_blank'>
                  <img
                  class="tieba-button"
                  :src="require(`../assets/${targetFolder}/nav/ico3.png`)"
                  >
              </a>
              <a class="dy-button" href="https://v.douyin.com/6HuBcKP/" target='_blank'>
                  <img
                  class="dy-button"
                  :src="require(`../assets/${targetFolder}/nav/ico4.png`)"
                  >
              </a>
              <img
              class="classification"
                :src="classification === false ? require(`../assets/${targetFolder}/nav/classification.png`) : require(`../assets/${targetFolder}/nav/classification_active.png`)"
              @click="classification = !classification;contactPanel = false;contactPanel1 = false">
            </div>
          </div>
        </div>
        <div class="mobile-bottom" v-if="classification">
            <div
              :class="[ nowIndex + 1  === item ? 'nav-active':'']"
                @click="go(index+1)"
                v-for="(item,index) in navArray"
                :key="item">
              <img
              class="go "
              :src="require(`../assets/${targetFolder}/nav/${item}${ nowIndex + 1  === item ? '_active':''}.png`)">
            </div>
        </div>
      </div>
    </div>
    <div class="news-content">
      <div class="container">
        <div class="content">
          <keep-alive>
            <router-view/>
          </keep-alive>
        </div>
      </div>
      <div class="footer">
        <div v-if="isDesktop" class="box">
          <p class="margin">健康游戏忠告</p>
          <p>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
          <p>Copyright © 2014-2020 Shanghai Gume Technology Co.,Ltd All Rights Reserved. 上海咕么信息科技有限公司 版权所有</p>
          <p>ICP备案号：沪ICP备16011695号-1 沪网文（2016）2295-133号</p>
        </div>
        <div v-if="!isDesktop" class="box">
          <p>健康游戏忠告</p>
          <p>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。</p>
          <p>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
          <p>Copyright © 2014-2020 Shanghai Gume Technology Co.,Ltd All Rights Reserved.</p>
          <p>上海咕么信息科技有限公司 版权所有</p>
          <p>ICP备案号：沪ICP备16011695号-1 沪网文（2016）2295-133号</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'NewsLayout',
  data () {
    return {
      contactPanel: false,
      contactPanel1: false,
      classification: false,
      nowIndex: 1,
      navArray: [
        1,
        2,
        3,
        4
      ]
    }
  },
  created () {
    require(`../styles/${this.targetFolder}/newsLayout.scss`)
  },
  mounted () {
    // console.log(this.$route)
  },
  computed: {
    targetFolder () {
      return this.$store.state.targetFolder
    },
    isDesktop () {
      return this.$store.state.isDesktop
    },
    nativeQuery () {
      var resultObj = {}
      var search = window.location.search
      if (search && search.length > 1) {
        search = search.substring(1)
        var items = search.split('&')
        for (var index = 0; index < items.length; index++) {
          if (!items[index]) {
            continue
          }
          var kv = items[index].split('=')
          resultObj[kv[0]] = typeof kv[1] === 'undefined' ? '' : kv[1]
        }
      }
      if (resultObj.header === undefined) {
        resultObj.header = '1'
      }
      return resultObj
    }

  },
  methods: {
    goBack () {
      history.back()
    },
    go (v) {
      if (v === 2) {
        if (this.$route.params.id) {
          this.$router.push({
            path: '/news/newest'
          })
        }
      } else {
        this.$router.push({
          path: '/',
          query: {
            anchor: v
          }
        })
      }
    }
  }
}
</script>

<style>

</style>
